import ReducerCreator from '../registerReducer';
import { buildStoreItemFromDictionary } from '../storeItemBuilder';
import * as ACTIONS from './onlineUsers.constants';
import { OnlineUserDto } from '../../models';
import { StoreItem, copy } from '../Store';

const r = new ReducerCreator<OnlineUserDto>()
    .register<OnlineUserDto[]>(ACTIONS.ONLINE_USERS_LOAD, () => {
        const newItem = new StoreItem<OnlineUserDto>();
        newItem.isLoading = true;
        return newItem;
    })
    .register<OnlineUserDto[]>(ACTIONS.ONLINE_USERS_LOAD_SUCCESS, (item, payload) => {
        const dic = {};
        payload.forEach(e => dic[e.userName] = e);
        return buildStoreItemFromDictionary(dic);
    })
    .register<OnlineUserDto[]>(ACTIONS.ONLINE_USERS_LOAD_ERROR, (item, payload) => {
        const newItem = new StoreItem<OnlineUserDto>();
        newItem.isLoading = false;
        newItem.isLoaded = false;
        newItem.hasError = true;
        newItem.error = payload;
        return newItem;
    })
    .register<OnlineUserDto>(ACTIONS.ONLINE_USER_REMOVE, (item, payload) => {
        const newItem = copy(item);
        if (newItem.dictionary[payload.userName]) {
            delete newItem.dictionary[payload.userName];
        }
        return newItem;
    })
    .register<OnlineUserDto>(ACTIONS.ONLINE_USER_UPDATE, (item, payload) => {
        const newItem = copy(item);
        newItem.dictionary[payload.userName] = payload;
        return newItem;
    });

export function onlineUsersReducer(state: StoreItem<OnlineUserDto> = new StoreItem<OnlineUserDto>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}